import { ColorEnum } from '@/constants/color'
import { hexToRgba } from '@/utils/hexToRgba'
import { ComponentType, FC } from 'react'
import { Pressable, PressableProps, StyleProp, StyleSheet, ViewStyle } from 'react-native'
import { SvgProps } from 'react-native-svg'

interface IconButtonProps extends PressableProps {
    size?: number
    containerColor?: string
    highlightContainerColor?: string
    Icon: ComponentType<SvgProps>
    style?: StyleProp<ViewStyle>
}

const IconButton: FC<IconButtonProps> = ({
    size = 40,
    containerColor,
    highlightContainerColor = ColorEnum.WHITE,
    Icon,
    style,
    ...props
}) => {
    return (
        <Pressable
            {...props}
            style={({ hovered, pressed }) => [
                styles.container,
                {
                    backgroundColor: containerColor,
                    height: size,
                    width: size,
                    borderRadius: size / 2,
                },
                props.onPress &&
                    hovered && { backgroundColor: hexToRgba(highlightContainerColor, 0.0625) },
                props.onPress &&
                    pressed && { backgroundColor: hexToRgba(highlightContainerColor, 0.25) },
                style,
            ]}
        >
            <Icon />
        </Pressable>
    )
}

const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        justifyContent: 'center',
    },
})

export default IconButton
